import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react';

export default function IdentificationCardIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M14.25 10.5H18m-3.75 3H18m-9.366 0a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z" stroke="currentColor"
        strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
      />
      <path
        d="M5.729 15.75a3 3 0 0 1 5.813 0" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.25 4.5H3.75a.75.75 0 0 0-.75.75v13.5a.75.75 0 0 0 .75.75h16.5a.75.75 0 0 0 .75-.75V5.25a.75.75 0 0 0-.75-.75Z"
        stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
      />
    </BaseIcon>
  );
}
